import * as Yup from "yup";
import { formatPercent, parseValueToNumber } from "../utils";

export const getInstallmentCalculatorSchema = (
  minTaxValue: number,
  maxTaxValue: number
) =>
  Yup.object({
    tax: Yup.number()
      .required("A taxa é obrigatória")
      .min(
        minTaxValue,
        `A taxa deve ser maior ou igual a ${formatPercent(minTaxValue, 3)}`
      )
      .max(
        maxTaxValue,
        `A taxa deve ser menor ou igual a ${formatPercent(maxTaxValue, 3)}`
      ),
    customInitialValue: Yup.boolean().optional(),
    initialValue: Yup.string().when("customInitialValue", {
      is: true,
      then: (schema) =>
        schema
          .required("O valor de entrada é obrigatório")
          .test("moreThan0", "Informe um valor maior que 0", (value) => {
            const numericValue = parseValueToNumber(value ?? "");
            if (isNaN(numericValue)) {
              return false;
            }

            return numericValue > 0;
          }),

      otherwise: (schema) => schema.notRequired().optional(),
    }),
  });

type FnReturn = ReturnType<typeof getInstallmentCalculatorSchema>;
export type InstallmentCalculatorSchema = Yup.InferType<FnReturn>;
